import { Record } from "immutable";
import { Memory } from "models/interfaces/memories/memory";

const defaultValues: Memory = {
    id: undefined,
    content: undefined,
    createdOn: undefined,
};

export default class MemoryRecord
    extends Record(defaultValues)
    implements Memory
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: Partial<Memory>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<MessagePartSuggestedMemory>} values
     */
    public with(values: Partial<Memory>): MemoryRecord {
        return new MemoryRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}
